import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getForm, isFormTypeTicketSale, isFormTypeRsvp } from 'common/entities/form/selectors';
import { getFormNode } from 'common/entities/formNode/selectors';

import { SuiContainer, SuiSpinner } from '@splashthat/sui';

import { TOP_LEVEL } from '../../constants/templateLibrary';
import FormEditorNode from './FormEditorNode';
import FormEditorLayoutFooter from './FormEditorLayoutFooter';
import HeadlineNode from './HeadlineNode';

import { openFormTemplateLibrary } from '../../actions/templateLibrary';
import { getFormId } from '../../selectors';

import './styles.styl';

const FormEditorLayout = (props) => (
    <div data-qa="FormEditorLayout">
        {!props.isTypeTicketSale && <HeadlineNode />}
        {props.rootNode && (
            <SuiContainer className="FormEditorLayout__content-container">
                <FormEditorNode formNodeId={props.rootNode.id} depth={0} />
            </SuiContainer>
        )}

        {!props.rootNode && (
            <SuiContainer variation="padded flex-center">
                <SuiSpinner />
            </SuiContainer>
        )}

        {props.children}

        <FormEditorLayoutFooter
            hasAddQuestionButton={props.isTypeTicketRSVP || props.isTypeTicketSale}
            onClickAddQuestion={props.openFormTemplateLibraryTopLevel}
        />
    </div>
);

FormEditorLayout.propTypes = {
    rootNode: PropTypes.object,
    openFormTemplateLibraryTopLevel: PropTypes.func.isRequired,
    isTypeTicketSale: PropTypes.bool.isRequired,
    isTypeTicketRSVP: PropTypes.bool.isRequired,
    children: PropTypes.node,
};
FormEditorLayout.defaultProps = {
    rootNode: null,
    formType: null,
    children: null,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const form = getForm(state, formId);
    const rootNode = form && form.root ? getFormNode(state, form.root) : undefined;
    const isTypeTicketSale = isFormTypeTicketSale(state, formId);
    const isTypeTicketRSVP = isFormTypeRsvp(state, formId);

    return {
        rootNode,
        isTypeTicketSale,
        isTypeTicketRSVP,
    };
};

const mapDispatchToProps = {
    openFormTemplateLibraryTopLevel: () => openFormTemplateLibrary(TOP_LEVEL),
};

export default connect(mapStateToProps, mapDispatchToProps)(FormEditorLayout);
